<template>
  <div class="headMenu">
    <div class="head-top">
      <div class="title">
        <div class="title-img"><img src="../assets/img/logo1.png" alt=""></div>
        <div>
          <div class="font-size20">技通天下在线学习平台</div>
          <div class="font-size12">Technology tongtianxia online learning platform</div>
        </div>
      </div>
<!--      <div class="searchBox">-->
<!--        <el-input placeholder="搜索您感兴趣的视频" v-model="searchInput">-->
<!--          <template slot="append">搜索</template>-->
<!--        </el-input>-->
<!--      </div>-->
      <div class="operationButton">
        <el-button v-if="token == null" type="primary" round @click="loginBtn">登录 | 注册</el-button>
        <el-button v-else type="primary" round @click="outLogin">退出登录</el-button>
      </div>
    </div>
    <div class="head-tab">
      <div style="display: flex">
        <div class="tab-title">
          <div class="title-box">全部课程分类</div>
          <ul class="title-list">
            <li class="title-list-item" v-for="(item,key) in curriculum" :key="key" >
              <div class="titleII" @click="openCurriculum(key, 'all', item.olCatgoryId, '')">{{item.olCatgoryName}}</div>
              <div class="list-item">
                <h3 @click="openCurriculum(key, 'all', item.olCatgoryId, '')">{{item.olCatgoryName}}</h3>
                <ul class="list-flex">
                  <li class="list-font" v-if="item.curriculums" v-for="(items, keys) in item.curriculums" :key="keys" @click="openCurriculum(key, keys, item.olCatgoryId, items.olCurriculumId)">
                    {{items.olCurriculumName}}
                  </li>
                </ul>
              </div>
            </li>
          </ul>
        </div>
        <el-menu :default-active="activeIndex" class="el-menu-demo" mode="horizontal" @select="handleSelect">
          <el-menu-item index="/home">首页</el-menu-item>
          <el-menu-item index="/curriculum">发现课程</el-menu-item>
          <el-menu-item index="/newsBulletin">新闻公告</el-menu-item>
          <el-menu-item index="/teachers">名师专题</el-menu-item>
          <el-menu-item index="/openClass">公开课</el-menu-item>
<!--          <el-menu-item index="6">联系我们</el-menu-item>-->
          <el-menu-item index="/learningRecord" v-if="token != null">学习记录</el-menu-item>
          <el-menu-item index="/userInformation" v-if="token != null">用户信息</el-menu-item>
        </el-menu>
      </div>
      <div class="mobile-box">
        <div class="face">
          <img v-if="user && user.faceImg != null" :src="user.faceImg" alt="">
          <span v-else></span>
        </div>
        <div class="name">{{user ? user.userName : ''}}</div>
      </div>
    </div>
  </div>
</template>

<script>
// import axios from 'axios'
import { mapMutations, mapState } from 'vuex'
// const curriculum1 = require('../../mock/curriculum.json')
export default {
  name: 'headMenu',
  computed: {
    ...mapState(['activeIndex'])
  },
  data () {
    return {
      searchInput: '',
      curriculum: [],
      token: sessionStorage.getItem('token') ? sessionStorage.getItem('token') : null,
      user: JSON.parse(sessionStorage.getItem('user')) ? JSON.parse(sessionStorage.getItem('user')) : null
    }
  },
  mounted () {
    let path = this.$route.path
    this.setActiveIndex(path)
    this.getData()
    // setInterval(this.open1, 300000)
  },
  methods: {
    ...mapMutations(['setActiveIndex']),
    getData () {
      let that = this
      this.$http({
        method: 'get',
        url: '/api/renren-fast/app/olcurriculum/olCatgoryInfos'
      }).then((result) => {
        that.curriculum = result.data.data
      })
    },
    open1 () {
      this.$notify({
        dangerouslyUseHTMLString: true,
        message: '<a href="../../static/answer.html" target="_blank">去答题</a>',
        position: 'bottom-right'
      })
    },
    loginBtn () {
      this.$router.push('/login')
    },
    handleSelect (key, keyPath) {
      let url = keyPath[0]
      this.$router.push(url)
    },
    outLogin () {
      this.$confirm('确认退出登录', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        sessionStorage.removeItem('token')
        this.$router.push('/login')
        this.$message({
          type: 'success',
          message: '退出登录成功!'
        })
      })
    },
    openCurriculum (key, keys, olCatgoryId, olCurriculumId) {
      this.setActiveIndex('/curriculum')
      this.$router.push({
        path: '/curriculum',
        query: {
          key: key,
          keys: keys,
          olCatgoryId: olCatgoryId,
          olCurriculumId: olCurriculumId
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.headMenu{
  width: 1200px;
  margin: 0px auto;
  .head-top{
    display: flex;
    justify-content: space-between;
    height: 80px;
    margin-top: 20px;
    .title{
      display: flex;
      .title-img{
        width: 60px;
        height: 40px;
        img{
          width: 100%;
          height: 100%;
        }
      }
      .font-size20{
        font-size: 24px;
        line-height: 30px;
        text-align: center;
      }
      .font-size12{
        font-size: 12px;
        color: #00c5c3;
        transform: scale(0.95,0.95);
      }
    }
    .searchBox{
      width: 520px;
    }
  }
  .head-tab{
    display: flex;
    justify-content: space-between;
    margin-top: 15px;
    .tab-title{
      margin-right: 30px;
      position: relative;
      z-index: 999;
      &:hover{
        .title-list{
          display: block;
        }
      }
      .title-box{
        width: 200px;
        background-color: #00c5c3;
        font-size: 20px;
        color: #ffffff;
        text-align: center;
        height: 50px;
        line-height: 50px;
        cursor: pointer;
      }
      .title-list{
        display: none;
        width: 200px;
        background: rgba(250,250,250,0.8);
        position: absolute;
        top: 50px;
        left: 0px;
        .title-list-item{
          width: 100%;
          height: 30px;
          line-height: 30px;
          padding: 0px 20px;
          cursor: pointer;
          .list-item{
            display: none;
            position: absolute;
            left: 200px;
            top: 0px;
            background: rgba(255,247,240,0.8);
            width: 600px;
            min-height: 300px;
            padding: 10px 20px;
            .list-flex{
              display: flex;
              flex-wrap: wrap;
              .list-font{
                padding-right: 30px;
              }
            }
          }
          &:hover{
            background: rgba(255,247,240,0.8);
            .list-item{
              display: block;
            }
          }
        }
      }
    }
    .tab-titleI{
      padding: 0px 30px;
      height: 50px;
      line-height: 50px;
      font-size: 18px;
      cursor: pointer;
    }
    .mobile-box{
      font-size: 18px;
      /*height: 50px;*/
      /*line-height: 50px;*/
      display: flex;
      .face{
        width: 40px;
        height: 40px;
        margin-right: 20px;
        border-radius: 20px;
        overflow: hidden;
        img{
          width: 100%;
          height: 100%;
        }
      }
      .name{
        line-height: 40px;
      }
    }
  }
}
</style>
<style>
.searchBox .el-input__inner{
  border-bottom-left-radius: 30px;
  border-top-left-radius: 30px;
}
.searchBox .el-input-group__append, .el-input-group__prepend{
  border-top-right-radius: 30px;
  border-bottom-right-radius: 30px;
  background-color: #00c5c3;
  color: #ffffff;
}
.operationButton .el-button--primary{
  background-color: #00c5c3;
  border-color: #00c5c3;
  width: 190px;
  font-size: 20px;
  border-radius: 30px;
}
.head-tab .el-menu--horizontal>.el-menu-item{
  height: 50px;
  line-height: 50px;
  font-size: 18px;
}
.head-tab .el-menu.el-menu--horizontal{
  border-bottom: none;
}
.head-tab .el-menu--horizontal>.el-menu-item.is-active{
  border-bottom: 3px solid #00c5c3;
}
</style>



// WEBPACK FOOTER //
// src/components/header.vue